import { type AsyncReturnType } from "type-fest";
import { type AppContext } from "~/lib/context";
import { getRequiredUser } from "~/lib/getRequiredUser";
import { type DeleteFiltersPresetInput } from "~/pages/api/filters-preset/delete-filters-preset";
export const deleteFiltersPreset = async (ctx: AppContext, input: DeleteFiltersPresetInput) => {
  const preset = await ctx.prisma.filtersPreset.findFirstOrThrow({
    where: {
      id: input.presetId,
      userId: getRequiredUser(ctx).id,
    },
    select: {
      id: true,
    },
  });

  return ctx.prisma.filtersPreset.delete({
    where: {
      id: preset.id,
    },
  });
};

export type DeleteFiltersPresetResult = AsyncReturnType<typeof deleteFiltersPreset>;
